module.exports = __webpack_public_path__ + "static/media/29.da2d9d0f.jpg";